import React, {Component} from "react";
import {connect} from "react-redux";
import {log, mapData, NullableType} from "./Tools";
import {LocationsType, StateBaseType} from "./store";
import * as actions from "./actions/action";
import {AnyAction, bindActionCreators, Dispatch} from "redux";
import {FlightType, LoginType} from "./actions/action";
// @ts-ignore
import HeatmapLayer from "react-leaflet-heatmap-layer";
import countBy from "lodash/countBy";

interface LocalStateType {
    highlight: boolean,
    mobileTouchStart: any
}

interface InputType {
    /* from parent */
    setUpdateFlightsAndLocationsFunction: any,
    mapZoom: any,
    setParentForceLineRender: any,
}

interface StateType {
    /* from redux props mapping*/
    locations: LocationsType,
    flights: FlightType[],
    mapZoomLeaflet: number,
    mapType: number,
    user: NullableType<LoginType>

}

interface DispatchType {
    /* from redux actions*/
    forceCenterMap: typeof actions.forceCenterMap,
}

type PropsType = InputType & StateType & DispatchType;

class LHeatmap extends Component<PropsType, LocalStateType> {

    constructor(props: PropsType) {
        super(props);

        this._getHeatPoints = this._getHeatPoints.bind(this);
        this._updateParentState = this._updateParentState.bind(this);

    }

    _updateParentState() {
    }

    _getPlaces() {
        const homeAirport = this.props.user?.homeAirport || 'hel';

        const airportCodes = this.props.flights.map(flight => [
            flight.from, flight.to
        ]).flat()
            //home airport has so many hits that it skews the heat map
            .filter(airportCode => airportCode !== homeAirport);
        if (this.props.flights.length && this.props.flights.find(flight => (flight.from === homeAirport) || (flight.to === homeAirport))) {
            return airportCodes.concat([homeAirport, homeAirport]);
        } else {
            return airportCodes;
        }
    }

    _getHeatPoints() {
        //TODO add google types https://forum.ionicframework.com/t/google-maps-typescript-error-cannot-find-name-google-discussion/49990/29
        const locationObjects = this.props.locations;
        const rawPlaces = this._getPlaces();
        const placesCountMap = countBy(rawPlaces);
        const placeCoordinates = Object.keys(placesCountMap).map(airport => {
            if (locationObjects[airport]) {
                return [
                    [locationObjects[airport].lat, locationObjects[airport].lng - 360, placesCountMap[airport]],
                    [locationObjects[airport].lat, locationObjects[airport].lng, placesCountMap[airport]],
                    [locationObjects[airport].lat, locationObjects[airport].lng + 360, placesCountMap[airport]],
                ];
            } else {
                return null;
            }
        });
        return placeCoordinates.flat();
    }

    /* TODO REMOVE FORCECENTERMAP
    componentDidUpdate(prevProps: Readonly<PropsType>, prevState: Readonly<LocalStateType>, snapshot?: any) {
        console.log('heatodidup');
        if (this._getHeatPoints().length) {
            console.log('heato', this.props.forceCenterMap);
            this.props.forceCenterMap();
        }

    }
*/

    render() {
        log('renderLHeatmap', this.props.mapZoomLeaflet);

        const heatColor = mapData()[this.props.mapType].heatColor;
        return (
            <HeatmapLayer
                radius={this.props.mapZoomLeaflet * 3.5}
                points={this._getHeatPoints()}
                longitudeExtractor={(m: any[]) => m[1]}
                latitudeExtractor={(m: any[]) => m[0]}
                max={this.props.mapZoomLeaflet > 5 ? 2 : 1}
                intensityExtractor={(m: any) => m[2]}
                gradient={heatColor}
            />
        );
    }
}

const mapStateToProps = (state: StateBaseType) => {
    return {
        flights: state.reducer.flights,
        locations: state.reducer.locations,
        mapZoomLeaflet: state.reducer.mapZoomLeaflet,
        mapType: state.reducer.mapType,
        user: state.reducer.user
    }
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators<any, any>(actions, dispatch);
};

export default connect<StateType, DispatchType, InputType, StateBaseType>(mapStateToProps, mapDispatchToProps)(LHeatmap);
